import { doc, getDoc } from "firebase/firestore"
import { useEffect, useState } from "react"

import { db } from "../configs/firebase"

const useSharedDocument = (token) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [document, setDocument] = useState(null)

  useEffect(() => {
    const fetchSharedDocument = async () => {
      try {
        setLoading(true)
        setError(null)

        const docRef = doc(db, "sharingDocuments", token)
        const docSnap = await getDoc(docRef)

        if (docSnap.exists()) {
          const data = docSnap.data()

          // Check if link is expired
          if (data._expiresAt && data._expiresAt.toDate() < new Date()) {
            setError("Link expired")
            return
          }

          // Fetch original document data if documentId exists
          if (data.documentId) {
            const originalDocRef = doc(db, "documents", data.documentId)
            const originalDocSnap = await getDoc(originalDocRef)

            if (originalDocSnap.exists()) {
              const docData = originalDocSnap.data()

              // Set the complete document data (same structure as DocumentContext)
              setDocument(docData)
            } else {
              setError("Original document not found")
            }
          } else {
            setError("No document ID found")
          }
        } else {
          setError("Document not found")
        }
      } catch (err) {
        console.error("Error fetching shared document:", err)
        setError("Failed to load document")
      } finally {
        setLoading(false)
      }
    }

    if (token) {
      fetchSharedDocument()
    } else {
      setError("Invalid token")
      setLoading(false)
    }
  }, [token])

  return {
    loading,
    error,
    document,
  }
}

export default useSharedDocument
